import * as React from "react";
const SvgMaximizeOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M0 0h24v24H0V0z" />
    <path d="M3 3h18v2H3V3z" />
  </svg>
);
export default SvgMaximizeOutlined;
